/**
 * VehicleInsurance actions
 */
export enum VehicleInsuranceActionEnum {
	/**
	 * Set insurance status to active
	 */
	ACTIVATE = 'activate',

	/**
	 * Set insurance status to pending
	 */
	PENDING = 'make_pending',

	/**
	 * Set insurance status to expired
	 */
	EXPIRE = 'make_expired',
}
